import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import MDButton from "components/MDButton";
import bgImage from "assets/images/infopro-logo.png";
import clade from "assets/images/cladecorp.jpeg"
import AuthService from "services/auth-service";
import { AuthContext } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { jwtDecode } from "jwt-decode";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

function Login() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [credentialsErros, setCredentialsError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [openDebtModal, setOpenDebtModal] = useState(false);
  const [debtMessage, setDebtMessage] = useState("");

  const [inputs, setInputs] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    usernameError: false,
    passwordError: false,
  });

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const changeHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);


    if (inputs.username.trim().length === 0) {
      setErrors({ ...errors, usernameError: true });
      setLoading(false);
      return;
    }

    if (inputs.password.trim().length < 6) {
      setErrors({ ...errors, passwordError: true });
      setLoading(false);
      return;
    }

    const newUser = { email: inputs.email, password: inputs.password };

    const myData = {username: inputs.username,password: inputs.password};

    try {
    const response = await AuthService.login(myData);
    const user = response.user;

    sessionStorage.setItem("access_token", response.access_token);
    sessionStorage.setItem("refresh_token", response.refresh_token);
    sessionStorage.setItem("user", JSON.stringify(user));
    
    authContext.login(response.access_token, response.refresh_token, user);

    navigate("/inicio");
    } catch (err) {

      const data = err?.response?.data;
      const status = err?.response?.status;

      const message =
        data?.message ||
        data?.errors?.[0]?.detail ||
        (data?.errors && typeof data.errors === "object"
          ? Object.values(data.errors)?.[0]?.[0]
          : null) ||
        err?.message ||
        "Error desconocido";

      // 🔥 SI ES BLOQUEO POR DEUDA
      if (status === 403) {
        setDebtMessage(message);
        setOpenDebtModal(true);
      } else {
        setCredentialsError(message);
      }
    } finally {
      setLoading(false);
    }
  };

  const primaryRed = "#D32F2F";

  return (
    
    <PageLayout>
      <Dialog
        open={openDebtModal}
        onClose={() => setOpenDebtModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#C62828",
          }}
        >
          Acceso restringido
        </DialogTitle>

        <DialogContent>
          <MDTypography
            variant="body1"
            sx={{
              textAlign: "center",
              mt: 1,
              mb: 2,
              lineHeight: 1.8,
            }}
          >
            {debtMessage}
          </MDTypography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <MDButton
            onClick={() => setOpenDebtModal(false)}
            sx={{
              background: "linear-gradient(90deg, #C62828, #8E0000)",
              color: "#fff",
              px: 4,
            }}
          >
            Entendido
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* PANEL IZQUIERDO */}
      <MDBox
        sx={{
          width: { xs: "100%", md: "50%" },
          minHeight: { xs: "40vh", md: "100vh" },
          background: "linear-gradient(135deg, #7A0000 0%, #C62828 50%, #1f1f1f 100%)",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          p: { xs: 4, md: 8 },
        }}
      >
        
        <MDBox
          sx={{
            display: { xs: "flex", md: "none" },
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            mb: 4,
          }}
        >
          <MDBox
            component="img"
            src={bgImage}
            alt="Infopro"
            sx={{
              width: "150px",
              backgroundColor: "#fff",
              borderRadius: "16px",
              p: 2,
            }}
          />
          <MDBox
            component="img"
            src={clade}
            alt="Cladecorp"
            sx={{
              width: "150px",
              backgroundColor: "#fff",
              borderRadius: "16px",
              p: 2,
            }}
          />
        </MDBox>

        {/* 💻 IMAGEN SUPERIOR SOLO EN PC */}
        <MDBox
          component="img"
          src={bgImage}
          alt="Infopro"
          sx={{
            display: { xs: "none", md: "block" },
            width: "260px",
            mb: 5,
            backgroundColor: "#fff",
            borderRadius: "16px",
            p: 2,
          }}
        />

        {/* TEXTO */}
        <MDTypography variant="h1" fontWeight="bold" color="white" mb={2}>
          Bienvenido
        </MDTypography>

        <MDTypography
          variant="h5"
          color="white"
          sx={{
            maxWidth: "460px",
            lineHeight: 1.8,
            opacity: 0.95,
            mb: 5,
          }}
        >
          Accede a la plataforma académica para gestionar procesos educativos y administrativos.
        </MDTypography>

        {/* 💻 IMAGEN INFERIOR SOLO EN PC */}
        <MDBox
          component="img"
          src={clade}
          alt="Cladecorp"
          sx={{
            display: { xs: "none", md: "block" },
            width: "260px",
            backgroundColor: "#fff",
            borderRadius: "16px",
            p: 2,
          }}
        />
      </MDBox>

      {/* PANEL DERECHO */}
      <MDBox
        sx={{
          width: { xs: "100%", md: "50%" },
          minHeight: { xs: "60vh", md: "100vh" },
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 4, md: 8 },
          backgroundColor: "#ffffff",
        }}
      >
        <MDBox sx={{ width: "100%", maxWidth: "520px" }}>
          <MDTypography variant="h2" fontWeight="bold" sx={{ color: primaryRed, textAlign: "center", mb: 2 }}>
            Inicio de sesión
          </MDTypography>

          <MDBox component="form" onSubmit={submitHandler}>
            <MDBox mb={4}>
              <MDInput
                type="text"
                label="Usuario"
                fullWidth
                value={inputs.username}
                name="username"
                onChange={changeHandler}
                error={errors.usernameError}
              />
            </MDBox>

            <MDBox mb={4}>
              <MDInput
                type={showPassword ? "text" : "password"}
                label="Contraseña"
                fullWidth
                name="password"
                value={inputs.password}
                onChange={changeHandler}
                error={errors.passwordError}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>     

            <MDButton
              fullWidth
              type="submit"
              disabled={loading}
              sx={{
                background: "linear-gradient(90deg, #C62828, #8E0000)",
                color: "#fff",
                borderRadius: "12px",
                height: "58px",
                fontWeight: "bold",
                fontSize: "1rem",
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "ENTRAR"}
            </MDButton>

            {credentialsErros && (
              <MDTypography variant="caption" color="error" sx={{ display: "block", mt: 2, textAlign: "center" }}>
                {credentialsErros}
              </MDTypography>
            )}
            <MDBox
              sx={{
                width: "100%",
                textAlign: "center",
                mt: 3,
                mb: 2,
              }}
            >
              <MDTypography
                variant="caption"
                sx={{
                  color: "#888",
                  fontSize: "12px",
                }}
              >
                © 2026, Desarrollado por el <br />
                <strong>INSTITUTO TECNOLÓGICO INFOPRO - CLADECORP</strong>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
    </PageLayout>
  );
}

export default Login;
